<template>
	<div>
		<div class="btns-top">
			<a class="btn btn-submit fa fa-save transition-fadeinup transition-delay-01" v-on:click="submitClickHandler"></a>
		</div>

		<div class="row">
			<div class="col-12 transition-fadeinup">
				<h2>Add a new language</h2>
				<form novalidate>

					<ul class="form">
						<li>
							<label>Language name *</label>
							<input type="text" placeholder="English" pattern="\S{2,}" name="language" required v-model="langName">
						</li>
						<li>
							<label>Language code *</label>
							<input type="text" placeholder="en_us" pattern="^[a-z]{2}(_[A-Z]{2})?$" name="code" required v-model="locale">
						</li>
						<li>
							<label>Region</label>
							<input type="text" placeholder="North America" pattern="\S{2,}" name="region" v-model="region">
						</li>
					</ul>

				</form>
			</div>
		</div>
	</div>
</template>

<script>

import general from '../../modules/general.js'
import xhrModule from '../../modules/xhrModule.js'
import validation from '../../modules/forms/validation.js'

export default {
	name: 'add-language',
	data () {
		return {
			locale: null,
			langName: null,
			region: null
		}
	},

	methods: {
		submitClickHandler (e) {
			e.preventDefault()

			// validate
			var form = this.$el.querySelector('form')
			var valid = validation.validate(form)
			if (!valid) return

			var obj = {
				id: 0,
				locale: this.locale,
				language: this.langName,
				region: this.region
			}

			var json = JSON.stringify(obj)
			var url = '/cms/api/markets'
			xhrModule.post(url, json, this.languagePostCompleted.bind(this))
		},

		languagePostCompleted (data) {
			general.saveAnimation()
			this.$router.push('/settings/languages')
		}
	}
}

</script>
